import React from 'react';
import PlanWizardReviewCard from './PlanWizardReviewCard';
import '../../../Styles/pages/product.scss';

const ReviewStep = ({
  wizardType,
  formik,
  t,
  currencySymbol,
  currencyFormat,
  equalParts,
  recoverMissed,
}) => (
  <div className="wizard-forms-wrapper p-grid p-nogutter">
    <div className="col-12 wizard-forms plan-wizard-review">
      <h4 className="plan-wizard-review-heading">{t('plan.wizard.review_heading')}</h4>
      <PlanWizardReviewCard
        wizardType={wizardType}
        values={formik.values}
        t={t}
        currencySymbol={currencySymbol}
        currencyFormat={currencyFormat}
        equalParts={equalParts}
        recoverMissed={recoverMissed}
        planName={formik.values.name}
        planDescription={formik.values.description}
      />
    </div>
  </div>
);

export default ReviewStep;
